import { render } from "./SmoothScrollProxy.vue?vue&type=template&id=17e6b780&ts=true"
import script from "./SmoothScrollProxy.vue?vue&type=script&lang=ts"
export * from "./SmoothScrollProxy.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/web-factory/barsmart/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__